import styled from 'styled-components'

export const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 140px));
  justify-content: start;
  gap: 14px;
  margin-bottom: 16px;

  @media (min-width: 1600px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 190px));
    gap: 18px;
  }
  @media (min-width: 2000px) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 230px));
    gap: 22px;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(150px, 1fr));
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const Body = styled.div`
  display: flex;
  gap: 14px;
  align-items: flex-start;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const Slicer = styled.div`
  flex: 0 0 210px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 800px) {
    flex-basis: auto;
    width: 100%;
  }
`

export const SlicerItem = styled.div`
  background: #fff;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
  padding: 10px 12px 12px;
  box-shadow: 0 4px 8px -3px rgba(0, 0, 0, 0.15);

  label {
    display: block;
    font-size: 15px;
    font-weight: 600;
    color: #4a4f57;
    margin-bottom: 6px;
  }
`

export const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

/* ---- KPIs (4) ---- */
export const KpiRow4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

export const Kpi = styled.div`
  background: #fff;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
  padding: 16px 16px 18px;
  text-align: center;
  box-shadow: 0 4px 8px -3px rgba(0, 0, 0, 0.15);

  .t {
    font-size: 17px;
    color: #6b7280;
    margin-bottom: 8px;
  }
  .v {
    font-size: 28px;
    font-weight: 700;
    color: #4a4f57;
    white-space: nowrap;
  }

  @media (max-width: 560px) {
    .v {
      font-size: 22px;
    }
  }
`

/* ---- tabela larga: altura fixa com scroll (vertical + horizontal) ---- */
export const TableScroll = styled.div`
  max-height: calc(100vh - 300px);
  min-height: 360px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`

export const ConcTable = styled.table`
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
  font-size: 14px;

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #8a9099;
    color: #fff;
    text-align: left;
    padding: 10px 12px;
    font-weight: 700;
    white-space: nowrap;
    border-bottom: 2px solid #4aa3df;
  }

  tbody td {
    padding: 10px 12px;
    text-align: left;
    vertical-align: top;
    color: #4a4f57;
    border-bottom: 1px solid #eef0f3;
  }

  @media (max-width: 560px) {
    font-size: 13px;
    thead th {
      padding: 8px 10px;
    }
    tbody td {
      padding: 8px 10px;
    }
  }
  tbody tr:nth-child(even) {
    background: #f7f8fa;
  }

  /* colunas numéricas à direita: Previsto(6) Depositado(7) Diferença(8) Ajustes(9) */
  th:nth-child(6),
  td:nth-child(6),
  th:nth-child(7),
  td:nth-child(7),
  th:nth-child(8),
  td:nth-child(8),
  th:nth-child(9),
  td:nth-child(9) {
    text-align: right;
    white-space: nowrap;
  }

  /* Banco(5) e Justificativa(10) quebram linha */
  td:nth-child(5),
  td:nth-child(10) {
    max-width: 150px;
    white-space: normal;
  }

  /* demais colunas de texto: sem quebra */
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4) {
    white-space: nowrap;
  }
`
